import { render, staticRenderFns } from "./historyCooperation.vue?vue&type=template&id=18955ea6&scoped=true&"
import script from "./historyCooperation.vue?vue&type=script&lang=js&"
export * from "./historyCooperation.vue?vue&type=script&lang=js&"
import style0 from "./historyCooperation.vue?vue&type=style&index=0&id=18955ea6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18955ea6",
  null
  
)

export default component.exports